import { TimeframeWithLocalTimes } from '@ftr/contracts/api/shared'
import { LocalTime } from '@js-joda/core'
import { AbstractBuilder } from './AbstractBuilder'

export class TimeframeWithLocalTimesBuilder extends AbstractBuilder<TimeframeWithLocalTimes> {
  static buildArray(...args: [string, string][]): TimeframeWithLocalTimes[] {
    return args.map(([start, end]) => new TimeframeWithLocalTimesBuilder(start, end).build())
  }

  constructor(startText = '09:00', endText = '17:00') {
    super({
      start: LocalTime.parse(startText),
      end: LocalTime.parse(endText),
    })
  }
}
